import React, { FC } from "react";
import { useParams } from "react-router-dom";

import {
  useEmployeeConditionSurveysSlideNavigation,
  useEmployeeConditionSubmissionForm,
  useRightSidebarState,
} from "~/hooks";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
  EmployeeLayoutRightSidebar,
} from "~/components/layouts";
import { RightSidebarToggleIconWithLabel } from "~/components/molecules";
import {
  EmployeeConditionDetail,
  EmployeeConditionSubmissionsCountCalendar,
} from "~/components/organisms";
import { NotFoundIndex } from "~/components/pages";

import { MyRoutes } from "~/config/Paths";

export const MembersInputEmployeeConditionSurveysShow: FC = () => {
  const { id = "" } = useParams<{ id: string }>();
  const query = new URLSearchParams(location.search);
  const businessSectionId = query.get("business_section_id") || "";
  const {
    searchCalendarOpenToggle,
    setCalendarOpen,
    isOpen,
    isCalendarOpen,
    currentOpenLabel,
  } = useRightSidebarState("isCalendarOpen");
  const {
    employeeConditionSurvey,
    isError,
    answers,
    isCreating,
    postDate,
    onChangePostDate,
    onChangeAnswer,
    handleSubmit,
  } = useEmployeeConditionSubmissionForm({
    employeeConditionId: id,
  });

  const { navigations } = useEmployeeConditionSurveysSlideNavigation({
    businessSectionId,
    selectedArray: [true, false],
  });

  const breadCrumbItems = [
    {
      label: "コンディション",
      href: MyRoutes.Members.inputEmployeeConditionSurveysIndex({
        q: { business_section_id: businessSectionId },
      }),
    },
    {
      label: "入力",
      href: MyRoutes.Members.inputEmployeeConditionSurveysIndex({
        q: { business_section_id: businessSectionId },
      }),
    },
  ];

  if (isError) return <NotFoundIndex />;

  return (
    <EmployeeLayout withRightSidebar breadCrumbItems={breadCrumbItems}>
      <EmployeeLayoutMainContent navigations={navigations} withRightSidebar>
        {employeeConditionSurvey && (
          <EmployeeConditionDetail
            employeeConditionSurvey={employeeConditionSurvey}
            answers={answers}
            onChangeAnswer={onChangeAnswer}
            handleSubmit={handleSubmit}
            isSubmitting={isCreating}
            postDate={postDate}
            onChangePostDate={onChangePostDate}
            className="mt-6"
          />
        )}
      </EmployeeLayoutMainContent>
      <EmployeeLayoutRightSidebar>
        <RightSidebarToggleIconWithLabel
          iconOnClick={searchCalendarOpenToggle}
          handleOnClose={isCalendarOpen ? undefined : setCalendarOpen}
          label={currentOpenLabel}
          isOpen={isOpen}
        >
          {isCalendarOpen && (
            <EmployeeConditionSubmissionsCountCalendar className="mt-6" />
          )}
        </RightSidebarToggleIconWithLabel>
      </EmployeeLayoutRightSidebar>
    </EmployeeLayout>
  );
};
